// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IUserUpdate {
	firstName: string;

	lastName: string;

	$type?: string | undefined;
}
export class UserUpdate {
	constructor(data?: IUserUpdate) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	@IsNotEmpty()
	firstName: string = "";

	@IsNotEmpty()
	lastName: string = "";

	static $type: string = "CoreApi.Models.View.UserUpdate, ";
	$type?: string | undefined = UserUpdate.$type;
}

